export enum PageType {
    Lobby,
    Room,
    HangUp,
    Ended,
}
